export class Development
{
	developmentId: number;
}
